import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/es5/locale/es';
//import '@fortawesome/fontawesome-free/css/all.css'
//import '@mdi/font/css/materialdesignicons.css'
//import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'


Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#00A4CF',
                secondary: '#458cc7',
                accent: '#8e44ad',
                error: '#ee5253',
                info: '#0abde3',
                success: '#10ac84',
                warning: '#ff9f43'
            },
        },
    },
    lang: {
        locales: {es},
        current: 'es',
    },
    icons: {
        iconfont: 'mdi',
    },
});
